module.exports = __webpack_public_path__ + "img/building-sm.28db0572.svg";